import React from 'react'
import Default from './default'
import Loading from './loading'

const View = (props) => {
	const {
		content,
		pathname,
		RenderDefault,
		//RenderLoading,
	} = props

	return (
		<RenderDefault content={content} pathname={pathname} />
	)
}

View.defaultProps = {
	RenderDefault: Default,
	RenderLoading: Loading,
}

export default View



// WEBPACK FOOTER //
// ./src/common/components/page/view.js